import React from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "../components/layout/SiteChrome";

const sections = [
  {
    title: "Acceptance of Terms",
    content: "By using True Value Mobiles's website or services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services. These terms apply to all visitors, users, and sellers who access or use our platform.",
  },
  {
    title: "Eligibility",
    content: "You must be at least 18 years of age to use our services. By submitting a quote request, you confirm that you are the legal owner of the device being sold and have the right to sell it. True Value Mobiles reserves the right to refuse service to anyone at its discretion.",
  },
  {
    title: "Quote & Pricing",
    content: "Quotes generated on True Value Mobiles are based on the information provided by you about the device's condition. The quoted price is valid for 24 hours from the time of generation. True Value Mobiles guarantees the quoted price subject to physical inspection confirming the stated condition. If the actual condition differs from the description, the technician will provide a revised quote that you may accept or decline.",
  },
  {
    title: "Pickup & Inspection",
    content: "Upon accepting a quote, our certified technician will contact you to schedule a free doorstep pickup. The pickup is available 7 days a week between 9 AM and 8 PM. During pickup, the technician will perform a physical inspection of the device. You may decline the sale at any point before the final payment is initiated without any penalty.",
  },
  {
    title: "Payment",
    content: "Payment is made via IMPS or UPI transfer to your registered bank account immediately after successful inspection and acceptance. True Value Mobiles does not charge any service fees from sellers. All prices quoted are the final take-home amounts. True Value Mobiles is not liable for delays caused by banking systems or incorrect bank details provided by the user.",
  },
  {
    title: "Device Condition & Disclosure",
    content: "You are responsible for accurately describing your device's condition. Misrepresentation of the device's condition (e.g., claiming 'no damage' when there are cracks) may result in a revised or cancelled offer. Repeated misrepresentation may result in account suspension.",
  },
  {
    title: "Data & Privacy",
    content: "Your personal data is handled in accordance with our Privacy Policy. You are responsible for backing up and erasing all personal data from the device before pickup. True Value Mobiles is not liable for any personal data remaining on sold devices. We recommend a factory reset before handing over the device.",
  },
  {
    title: "Cancellation & Refund",
    content: "There is no cancellation fee if you decide not to sell after receiving the quote or the revised offer. Once payment has been made and the device has been handed over, the transaction is considered final. If a payment error occurs, True Value Mobiles will resolve it within 3 business days.",
  },
  {
    title: "Prohibited Devices",
    content: "True Value Mobiles does not accept stolen, lost, or blacklisted devices. You confirm that the device is not reported stolen and is not linked to any active police complaint. Submitting a stolen device is a criminal offence. True Value Mobiles cooperates with law enforcement and may report such incidents.",
  },
  {
    title: "Limitation of Liability",
    content: "True Value Mobiles's liability is limited to the value of the transaction. We are not liable for any indirect, incidental, or consequential damages arising from the use of our platform or services. The maximum liability of True Value Mobiles in any dispute shall not exceed the quoted price of the device.",
  },
  {
    title: "Governing Law",
    content: "These Terms are governed by the laws of India. Any disputes arising from or relating to these Terms shall be subject to the exclusive jurisdiction of the courts located in Gurugram, Haryana, India.",
  },
  {
    title: "Changes to Terms",
    content: "True Value Mobiles reserves the right to update these Terms at any time. Continued use of our services after any changes constitutes your acceptance of the new Terms. We will notify users of significant changes via SMS or email where applicable.",
  },
];

export default function TermsPage() {
  return (
    <div className="page-bg">
      <Header />

      {/* Hero */}
      <section style={{ background: "var(--indigo)", padding: "52px 20px 48px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>
          <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, color: "rgba(255,255,255,0.55)", textDecoration: "none", marginBottom: 18, transition: "color 0.2s" }}
            onMouseEnter={e => (e.currentTarget.style.color = "#fff")} onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}>
            ← Back to Home
          </Link>
          <div style={{ display: "inline-block", background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 100, padding: "4px 14px", fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.8)", marginBottom: 14 }}>
            Effective: January 1, 2026
          </div>
          <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(26px,4vw,40px)", color: "#fff", letterSpacing: "-0.8px", marginBottom: 12 }}>
            Terms & Conditions
          </h1>
          <p style={{ fontSize: 15, color: "rgba(255,255,255,0.72)", lineHeight: 1.7, maxWidth: 560 }}>
            Please read these terms carefully before using True Value Mobiles. They outline your rights and responsibilities when selling a device through our platform.
          </p>
        </div>
      </section>

      {/* Content */}
      <section style={{ maxWidth: 860, margin: "0 auto", padding: "56px 20px 72px" }}>
        {/* Notice box */}
        <div style={{ background: "#fff8ec", border: "1.5px solid #fde68a", borderRadius: 16, padding: "18px 22px", marginBottom: 40, display: "flex", gap: 12, alignItems: "flex-start" }}>
          <span style={{ fontSize: 20, flexShrink: 0 }}>📋</span>
          <p style={{ fontSize: 14, color: "#92400e", lineHeight: 1.65 }}>
            <strong>Important:</strong> By using True Value Mobiles's services, you acknowledge that you have read, understood, and agreed to these Terms and Conditions in their entirety.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {sections.map((sec, i) => (
            <div key={i} style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 16, padding: "24px 22px", boxShadow: "var(--shadow-sm)" }}>
              <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
                <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 13, color: "var(--brand)", flexShrink: 0, width: 28, paddingTop: 2 }}>{String(i + 1).padStart(2, "0")}.</span>
                <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 17, color: "var(--text)" }}>{sec.title}</h2>
              </div>
              <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.75, paddingLeft: 40 }}>{sec.content}</p>
            </div>
          ))}
        </div>

        {/* Contact box */}
        <div style={{ marginTop: 40, background: "var(--indigo-light)", border: "1.5px solid var(--border-bright)", borderRadius: 16, padding: "22px 24px" }}>
          <h3 style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 16, color: "var(--indigo)", marginBottom: 8 }}>Questions about these Terms?</h3>
          <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.65 }}>
            Contact our legal team at <strong>legal@truevaluemobiles.in</strong> or call us at <strong>1800-123-4567</strong> (toll-free, Mon–Sat 9AM–6PM).
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
